import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';
import { API_BASE_URL } from '@/config/api';

const httpClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

function isAuthRequest(url) {
  return typeof url === 'string' && (
    url.includes('/nora_user/token') ||
    url.includes('/nora_user/details')
  );
}

httpClient.interceptors.request.use(async (config) => {
  const authStore = useAuthStore();
  const nextConfig = { ...config };

  if (!isAuthRequest(nextConfig.url)) {
    const hasSession = await authStore.ensureValidSession();
    if (hasSession && authStore.accessToken) {
      nextConfig.headers = {
        ...(nextConfig.headers || {}),
        Authorization: `Bearer ${authStore.accessToken}`,
      };
    }
  }

  return nextConfig;
});

httpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const authStore = useAuthStore();
    const originalRequest = error.config || {};
    const statusCode = error.response?.status;

    if (
      statusCode === 401 &&
      !originalRequest._retry &&
      !isAuthRequest(originalRequest.url)
    ) {
      originalRequest._retry = true;

      try {
        await authStore.refreshAccessToken();
        originalRequest.headers = {
          ...(originalRequest.headers || {}),
          Authorization: `Bearer ${authStore.accessToken}`,
        };
        return httpClient(originalRequest);
      } catch (refreshError) {
        authStore.logout({ redirectToLogin: true });
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default httpClient;
